export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"},{"hid":"description","name":"description","content":"Shapoorji Pallonji is a leading Infrastructure & Real Estate Construction Company in India, delivering innovative and sustainable building solutions."},{"hid":"keywords","name":"keywords","content":"virtual travel experiences, interactive tours, 360 virtual tours, digital travel guide, immersive tourism, panoramic views, spatial imaging, smartphone photography, smartphone scanning, phone based virtual tours"},{"property":"og:title","content":"Shapoorji Pallonji"},{"property":"og:description","content":"Shapoorji Pallonji is a leading Infrastructure & Real Estate Construction Company in India, delivering innovative and sustainable building solutions."},{"property":"og:type","content":"website"},{"property":"og:url"},{"property":"og:image","content":"https://d19e0oo8ox6zs5.cloudfront.net/static/images/homepage-background.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical"}],"style":[],"script":[],"noscript":[],"title":"Shapoorji Pallonji: Infrastructure & Real Estate Construction Company in India","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true